import { isDeliveryEmail, normalizeDeliveryEmail } from "@lc/shared/email-address";
import { z } from "zod/v4";

const phoneRegex = /^\+[1-9]\d{7,14}$/;

export const orderFormSchema = z.object({
  name: z.string().min(2, "Имя должно содержать минимум 2 символа").max(100, "Имя слишком длинное"),
  surname: z
    .string()
    .min(2, "Фамилия должна содержать минимум 2 символа")
    .max(100, "Фамилия слишком длинная"),
  email: z
    .string()
    .transform(normalizeDeliveryEmail)
    .refine(isDeliveryEmail, "Введите корректный email"),
  phone: z.string().regex(phoneRegex, "Введите номер в формате + код страны и номер"),
  agreedToOferta: z.boolean().refine((val) => val === true, {
    message: "Необходимо согласие с офертой",
  }),
  agreedToPrivacy: z.boolean().refine((val) => val === true, {
    message: "Необходимо согласие на обработку персональных данных",
  }),
  agreedToNewsletter: z.boolean().optional(),
});

export type OrderFormData = z.infer<typeof orderFormSchema>;

export interface OrderResponse {
  success: boolean;
  paymentUrl?: string;
  orderId?: string;
  error?: string;
}
